import template from './upcoming-rsvps.tpl.html';

class UpcomingRsvpsCtrl {
    constructor($scope, $injector) {
        this.scope = $scope;
        this.injector = $injector;
        this.state = this.injector.get('$state');
        this.env = this.injector.get('Env');
        this.deposit = this.injector.get('Deposit');
        this.rsvpsStore = this.injector.get('Rsvps');
        this.userStore = this.injector.get('Users');
        this.resourceSelect = this.injector.get('ResourceSelect');
        this.api = this.injector.get('$http');
        this.alert = this.injector.get('Alert');
        this.rsvpStatusEmailHelper = this.injector.get('RsvpsStatusEmailHelper');
        this.templateCache = this.injector.get('$templateCache');

        this.data = [];
        this.rsvpStates = [];
        this.elementLabelTemplate = '{{element.title}}, {{element.pax}}<span ng-if="element.custom_label">, {{element.custom_label}}</span></span>';
        this._checkCustomElementLabelTemplate();

        this.rsvpsFastPipe = this.rsvpsStore.create({
            persists: false,
            listView: 'UpcomingBookings'
        });

        this.loading = true;
        this.sumPaxPlanned = 0;
        this.sumSeatplanElementPax = 0;

        this.columnsForFastPipe = [];
        this.columnsToDisplay = [];

        this._prepareColumns()
        this._initWatchers();
        this._configureFastPipe();
        this._loadDeposits();
    }

    changeRsvpStatus(rsvpRow) {
        this.api.get(`rsvps/${rsvpRow.id}?include=guestlist,contact`).then((response) => {
            const guestlist = _.get(response, 'data.data.guestlist.data', null),
                contact = _.get(response, 'data.data.contact.data', null),
                fullRsvp = _.get(response, 'data.data', null);

            this.rsvpStatusEmailHelper.startFlow(fullRsvp, contact, guestlist).then(() => {
                this._updateFastPipeData();
            }, () => {
                this._updateFastPipeData();
            })
        }, (response) => {
            this.alert.handle(response);
        });
    }

    // Private functions
    _initWatchers() {
        this.scope.$watch(() => {
            return this.contact;
        }, () => {
            if (this.contact) {
                this._updateFastPipeData();
            }
        });

        this.scope.$watch(() => {
            return this.showElements;
        }, () => {
            this._updateFastPipeData();
        });

        this.scope.$watch(() => {
            return this.yearToDisplay;
        }, () => {
            this._updateFastPipeData();
        });
    }

    _loadDeposits() {
        this.deposit.getRemoteDeposit('rsvps', 'states').then((data) => {
            this.rsvpStates = data;
        });
    }

    _configureFastPipe() {
        this.rsvpsFastPipe.commit('setColumns', this.columnsForFastPipe);
        const minDate = new Date(),
            maxDate = new Date();
        minDate.setMonth(0);
        maxDate.setMonth(11);
        minDate.setDate(1);
        maxDate.setDate(31);
        maxDate.setHours(23, 59, 59);
        minDate.setYear(this.yearToDisplay);
        maxDate.setYear(this.yearToDisplay);

        this.rsvpsFastPipe.commit('setFilter', {
            key: 'guestlist.date',
            value: {
                min: minDate,
                max: maxDate
            }
        });

        this.rsvpsFastPipe.commit('setIncludeDeletedGuestlists', true);
    }

    _updateFastPipeData() {
        if (!this.yearToDisplay) {
            return;
        }
        this.loading = true;
        this._configureFastPipe();
        this.rsvpsFastPipe.commit('setSort', {'area_start_time': 'asc'});
        this.rsvpsFastPipe.commit('setPermanentFilters', {'contact.id': this.contact.id});
        this.rsvpsFastPipe.commit('setPagination', {perPage: -1});
        this.rsvpsFastPipe.dispatch('getData').then(() => {
            this.items = this.rsvpsFastPipe.state.data;
            this._recalculateSums();
            this.loading = false;
        });
    }

    _recalculateSums() {
        this.sumPaxPlanned = this.items.reduce((out, row) => {
            return out + row.pax_planned
        }, 0);

        this.sumSeatplanElementPax = this.items.reduce((out, row) => {
            return out + row.seatplan_element_pax
        }, 0);
    }

    openRsvpInSeatplan(rsvp) {
        if (rsvp.guestlist.seatplan_id) {
            this.state.go('app.guestlists.rsvps.seats', {gid: rsvp.guestlist.id, rsvpId: rsvp.id});
        } else {
            this.state.go('app.guestlists.rsvps.details.overview', {gid: rsvp.guestlist.id, id: rsvp.id});
        }
    }

    _checkCustomElementLabelTemplate() {
        const customTemplate = _.get(this.userStore.state, 'company.settings.companies.special_views.upcoming-rsvps.custom-se-elements-template', '');
        if (customTemplate) {
            this.elementLabelTemplate = customTemplate;
        }
    }

    _prepareColumns() {
        this.columnsForFastPipe =_.get(this.userStore.state, 'company.settings.contacts.upcoming-rsvps-fast-pipe-columns', []);
        this.columnsToDisplay = _.get(this.userStore.state, 'company.settings.contacts.upcoming-rsvps-display-columns', [])
            .map((value, index) => {
                const key = btoa(value.label + value.template).substring(0, 10);
                return {
                    ...value,
                    key,
                    templatePath: 'upcomingRsvpsList/column-' + key + '.tpl.html'
                }
            });

        this.columnsToDisplay.forEach((value) => {
            this.templateCache.put(value.templatePath, value.template)
        })
    }
}

UpcomingRsvpsCtrl.$inject = [
    '$scope',
    '$injector'
];

angular
    .module('festzelt-os.components')
    .component('upcomingRsvps', {
        bindings: {
            contact: '<',
            showElements: '<',
            yearToDisplay: '<'
        },
        controller: UpcomingRsvpsCtrl,
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/components/components/upcoming-rsvps/upcoming-rsvps.js